import blog from '../objects/blog/index';

// run all related funcs here
blog();
